import React from 'react';
import { DesignSet1, DesignSet2, DesignSet3 } from '..';

export const reasonData = [
  {
    img: <DesignSet1 />,
    title: '가게의 특성을 적극 반영',
    description:
      '저희 가게 인테리어 메인 컬러가 갈색과 노란색인데,\n이 부분을 적극적으로 반영하여 쿠폰 디자인을 제작해주셨습니다!',
  },
  {
    img: <DesignSet2 />,
    title: '원하는 스타일 그대로',
    description:
      '막연하게 귀엽지만, 세련된 디자인으로 제작되면 좋겠다고\n미팅 때 말씀 드렸는데, 저의 니즈를 정확하게 반영해주셨어요!',
  },
  {
    img: <DesignSet3 />,
    title: '트렌디한 디자인으로 수익 UP',
    description:
      '막연하게 귀엽고 친근한 디자인으로 제작되면 좋겠다고\n미팅 때 말씀 드렸는데, 저의 니즈를 정확하게 반영해주셨어요!',
  },
];
